/**
 * @architecture-header 1
 * @layer routes
 * @domain workspace-shell
 * @responsibility Provide the phone-only full-page frame and canonical soft-square back control.
 * @state-owner parent owns navigation state
 * @allowed-imports React; shared icons and translator
 * @forbidden desktop modal chrome; business data; direct API client
 * @public-api phone utility and detail pages
 * @side-effects invokes parent navigation callbacks
 * @tests frontend/apps/web/e2e/workspace.spec.ts
 */

import type { ReactNode } from 'react';
import { BackIcon } from '../../shared/components/VispoIcon';
import { useTranslator } from '../../shared/model/use-workspace';

export function MobilePageFrame({
  actions,
  children,
  focused = false,
  onBack,
  title,
}: {
  actions?: ReactNode;
  children: ReactNode;
  focused?: boolean;
  onBack(): void;
  title: string;
}) {
  const t = useTranslator();
  return (
    <section className={`mobile-page${focused ? ' mobile-page--focused' : ''}`}>
      <header className="mobile-page__header">
        <button aria-label={t('返回')} className="mobile-page__back" type="button" onClick={onBack}>
          <BackIcon />
        </button>
        <h1>{title}</h1>
        <div className="mobile-page__actions">{actions}</div>
      </header>
      <div className="mobile-page__body">{children}</div>
    </section>
  );
}
